import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { SharedUiSingleUnitForm } from '../shared-ui/form/shared-ui-forms';

export interface SearchWizardComposerProps {
  navigateTo?: any;
  onUpdateResults?: any;
  showFormBtn?: boolean;
  dateless?: boolean;
}

export const SearchWizardComposer: React.FunctionComponent<SearchWizardComposerProps> = ({
  navigateTo,
  onUpdateResults,
  showFormBtn,
  dateless,
}) => (
  <div className="all-y-padding-three" data-stid="single-offer-search">
    <h3 className="is-visually-hidden">
      <LocalizedText message={'hotels.infosite.availabilityWizard.changeSearch.a11yLabel'} />
    </h3>
    {dateless && <SharedUiSingleUnitForm onSubmit={navigateTo} onChange={navigateTo} showFormBtn={showFormBtn} />}
    {!dateless && <SharedUiSingleUnitForm onSubmit={navigateTo} onChange={onUpdateResults} showFormBtn={showFormBtn} />}
  </div>
);

SearchWizardComposer.displayName = 'SearchWizardComposer';
